// extracted by mini-css-extract-plugin
export default {"myClaimsTable":"MyClaimsTable_myClaimsTable__4lE-Y","myClaimActions":"MyClaimsTable_myClaimActions__xYNQz","sortingIcon":"MyClaimsTable_sortingIcon__-AbAV"};